/* tslint:disable */
/* eslint-disable */
/**
 * Simple API with JWT Auth
 * A minimal OpenAPI spec with JWT authentication and simple models.
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { updateIsDeleted, isDeleted, isNew, updateIsNew } from "@/api/util";
import { registerMeta } from "@/api/meta";
import {
  propertyMeta,
  typeMeta,
  typeMetaEnum,
  MetaTypesBase,
  EnumMetaType,
  MetaType,
  MetaTypeBase,
  PropertyMeta,
  AssignOptions,
  AssignOptionsRequired,
  FilterVarsType,
  getAssignOptions,
} from "../common";

// May contain unused imports in some cases
// @ts-ignore
import type {
  DBHistory,
  DBHistoryOptional,
  DBHistoryMetaI,
  DBHistoryTrackedI,
} from "./dbhistory";
import { DBHistoryTracked, DBHistoryMeta } from "./dbhistory";
// May contain unused imports in some cases
// @ts-ignore
import type {
  Deletable,
  DeletableOptional,
  DeletableMetaI,
  DeletableTrackedI,
} from "./deletable";
import { DeletableTracked, DeletableMeta } from "./deletable";
// May contain unused imports in some cases
// @ts-ignore
import type {
  JpClassSectionLookupBase,
  JpClassSectionLookupBaseOptional,
  JpClassSectionLookupBaseMetaI,
  JpClassSectionLookupBaseTrackedI,
} from "./jp-class-section-lookup-base";
import {
  JpClassSectionLookupBaseTracked,
  JpClassSectionLookupBaseMeta,
} from "./jp-class-section-lookup-base";
// May contain unused imports in some cases
// @ts-ignore
import type {
  JpClassSectionLookupRef,
  JpClassSectionLookupRefOptional,
  JpClassSectionLookupRefMetaI,
  JpClassSectionLookupRefTrackedI,
} from "./jp-class-section-lookup-ref";
import {
  JpClassSectionLookupRefTracked,
  JpClassSectionLookupRefMeta,
} from "./jp-class-section-lookup-ref";

/**
 *
 * @export
 * @interface JpClassSectionLookupFull
 */
export interface JpClassSectionLookupFullOptional extends DBHistoryOptional {
  /**
   *
   * @type {number}
   * @memberof JpClassSectionLookupFull
   */
  assignId?: number;
  /**
   *
   * @type {string}
   * @memberof JpClassSectionLookupFull
   */
  sectionName?: string;
  /**
   *
   * @type {boolean}
   * @memberof JpClassSectionLookupFull
   */
  active?: boolean;
  /**
   *
   * @type {number}
   * @memberof JpClassSectionLookupFull
   */
  displayOrder?: number;
  /**
   *
   * @type {string}
   * @memberof JpClassSectionLookupFull
   */
  svgUrl?: string;
  /**
   *
   * @type {boolean}
   * @memberof JpClassSectionLookupFull
   */
  isDeleted?: boolean;
  /**
   *
   * @type {boolean}
   * @memberof JpClassSectionLookupFull
   */
  isNew?: boolean;
  /**
   *
   * @type {string}
   * @memberof JpClassSectionLookupFull
   */
  updatedOn?: Date;
  /**
   *
   * @type {string}
   * @memberof JpClassSectionLookupFull
   */
  updatedBy?: string;
  /**
   *
   * @type {string}
   * @memberof JpClassSectionLookupFull
   */
  createdOn?: Date;
  /**
   *
   * @type {string}
   * @memberof JpClassSectionLookupFull
   */
  createdBy?: string;
}

export interface JpClassSectionLookupFull
  extends
    JpClassSectionLookupFullOptional,
    DBHistory,
    Deletable,
    JpClassSectionLookupBase,
    JpClassSectionLookupRef {
  /**
   *
   * @type {number}
   * @memberof JpClassSectionLookupFull
   */
  assignId: number;
  /**
   *
   * @type {string}
   * @memberof JpClassSectionLookupFull
   */
  sectionName?: string;
  /**
   *
   * @type {boolean}
   * @memberof JpClassSectionLookupFull
   */
  active?: boolean;
  /**
   *
   * @type {number}
   * @memberof JpClassSectionLookupFull
   */
  displayOrder?: number;
  /**
   *
   * @type {string}
   * @memberof JpClassSectionLookupFull
   */
  svgUrl?: string;
  /**
   *
   * @type {boolean}
   * @memberof JpClassSectionLookupFull
   */
  isDeleted?: boolean;
  /**
   *
   * @type {boolean}
   * @memberof JpClassSectionLookupFull
   */
  isNew?: boolean;
  /**
   *
   * @type {string}
   * @memberof JpClassSectionLookupFull
   */
  updatedOn?: Date;
  /**
   *
   * @type {string}
   * @memberof JpClassSectionLookupFull
   */
  updatedBy?: string;
  /**
   *
   * @type {string}
   * @memberof JpClassSectionLookupFull
   */
  createdOn?: Date;
  /**
   *
   * @type {string}
   * @memberof JpClassSectionLookupFull
   */
  createdBy?: string;
}

export interface JpClassSectionLookupFullTrackedI extends DBHistoryOptional {
  /**
   *
   * @type {number}
   * @memberof JpClassSectionLookupFull
   */
  assignId?: number;
  assignIdIsSet: boolean;
  /**
   *
   * @type {string}
   * @memberof JpClassSectionLookupFull
   */
  sectionName?: string;
  sectionNameIsSet: boolean;
  /**
   *
   * @type {boolean}
   * @memberof JpClassSectionLookupFull
   */
  active?: boolean;
  activeIsSet: boolean;
  /**
   *
   * @type {number}
   * @memberof JpClassSectionLookupFull
   */
  displayOrder?: number;
  displayOrderIsSet: boolean;
  /**
   *
   * @type {string}
   * @memberof JpClassSectionLookupFull
   */
  svgUrl?: string;
  svgUrlIsSet: boolean;
  /**
   *
   * @type {boolean}
   * @memberof JpClassSectionLookupFull
   */
  isDeleted?: boolean;
  isDeletedIsSet: boolean;
  /**
   *
   * @type {boolean}
   * @memberof JpClassSectionLookupFull
   */
  isNew?: boolean;
  isNewIsSet: boolean;
  /**
   *
   * @type {string}
   * @memberof JpClassSectionLookupFull
   */
  updatedOn?: Date;
  updatedOnIsSet: boolean;
  /**
   *
   * @type {string}
   * @memberof JpClassSectionLookupFull
   */
  updatedBy?: string;
  updatedByIsSet: boolean;
  /**
   *
   * @type {string}
   * @memberof JpClassSectionLookupFull
   */
  createdOn?: Date;
  createdOnIsSet: boolean;
  /**
   *
   * @type {string}
   * @memberof JpClassSectionLookupFull
   */
  createdBy?: string;
  createdByIsSet: boolean;
}

transformDatesMap.set(
  "JpClassSectionLookupFull",
  function (model: JpClassSectionLookupFull) {
    if (typeof model.updatedOn == "string")
      model.updatedOn = new Date(model.updatedOn);
    if (typeof model.createdOn == "string")
      model.createdOn = new Date(model.createdOn);
  },
);

export type JpClassSectionLookupFullMetaI = MetaType<{
  //isDate: false
  //isDatetime: false
  assignId: PropertyMeta<MetaTypeBase<number>>;
  //isDate: false
  //isDatetime: false
  sectionName: PropertyMeta<MetaTypeBase<string>>;
  //isDate: false
  //isDatetime: false
  active: PropertyMeta<MetaTypeBase<boolean>>;
  //isDate: false
  //isDatetime: false
  displayOrder: PropertyMeta<MetaTypeBase<number>>;
  //isDate: false
  //isDatetime: false
  svgUrl: PropertyMeta<MetaTypeBase<string>>;
  //isDate: false
  //isDatetime: false
  isDeleted: PropertyMeta<MetaTypeBase<boolean>>;
  //isDate: false
  //isDatetime: false
  isNew: PropertyMeta<MetaTypeBase<boolean>>;
  //isDate: false
  //isDatetime: true
  updatedOn: PropertyMeta<MetaTypeBase<Date>>;
  //isDate: false
  //isDatetime: false
  updatedBy: PropertyMeta<MetaTypeBase<string>>;
  //isDate: false
  //isDatetime: true
  createdOn: PropertyMeta<MetaTypeBase<Date>>;
  //isDate: false
  //isDatetime: false
  createdBy: PropertyMeta<MetaTypeBase<string>>;
}>;

export var JpClassSectionLookupFullMeta: JpClassSectionLookupFullMetaI =
  {} as JpClassSectionLookupFullMetaI;
JpClassSectionLookupFullMeta = typeMeta("JpClassSectionLookupFull", {
  assignId: propertyMeta("assignId", false, true, true, MetaTypesBase.number),
  sectionName: propertyMeta(
    "sectionName",
    false,
    false,
    false,
    MetaTypesBase.string,
  ),
  active: propertyMeta("active", false, false, false, MetaTypesBase.boolean),
  displayOrder: propertyMeta(
    "displayOrder",
    false,
    false,
    false,
    MetaTypesBase.number,
  ),
  svgUrl: propertyMeta("svgUrl", false, false, false, MetaTypesBase.string),
  isDeleted: propertyMeta(
    "isDeleted",
    false,
    false,
    false,
    MetaTypesBase.boolean,
  ),
  isNew: propertyMeta("isNew", false, false, false, MetaTypesBase.boolean),
  updatedOn: propertyMeta("updatedOn", false, false, false, MetaTypesBase.Date),
  updatedBy: propertyMeta(
    "updatedBy",
    false,
    false,
    false,
    MetaTypesBase.string,
  ),
  createdOn: propertyMeta("createdOn", false, false, false, MetaTypesBase.Date),
  createdBy: propertyMeta(
    "createdBy",
    false,
    false,
    false,
    MetaTypesBase.string,
  ),
});

const metaI = JpClassSectionLookupFullMeta;

registerMeta(() => {
  metaI.interfaces = metaI.interfaces.concat([JpClassSectionLookupRefMeta]);
  metaI.assignId.inheritedFrom = JpClassSectionLookupRefMeta.assignId;
  metaI.interfaces = metaI.interfaces.concat([JpClassSectionLookupBaseMeta]);
  metaI.sectionName.inheritedFrom = JpClassSectionLookupBaseMeta.sectionName;
  metaI.active.inheritedFrom = JpClassSectionLookupBaseMeta.active;
  metaI.displayOrder.inheritedFrom = JpClassSectionLookupBaseMeta.displayOrder;
  metaI.svgUrl.inheritedFrom = JpClassSectionLookupBaseMeta.svgUrl;
  metaI.interfaces = metaI.interfaces.concat([DeletableMeta]);
  metaI.isDeleted.inheritedFrom = DeletableMeta.isDeleted;
  metaI.isNew.inheritedFrom = DeletableMeta.isNew;
  metaI.interfaces = metaI.interfaces.concat([DBHistoryMeta]);
  metaI.updatedOn.inheritedFrom = DBHistoryMeta.updatedOn;
  metaI.updatedBy.inheritedFrom = DBHistoryMeta.updatedBy;
  metaI.createdOn.inheritedFrom = DBHistoryMeta.createdOn;
  metaI.createdBy.inheritedFrom = DBHistoryMeta.createdBy;
});

export class JpClassSectionLookupFullTracked
  extends DBHistoryTracked
  implements JpClassSectionLookupFullTrackedI
{
  changeTracker: boolean = false;
  //isNew: boolean = false
  assignId__I?: number = undefined;

  get assignIdIsSet() {
    return this.assignId !== undefined;
  }
  set assignIdIsSet(v: boolean) {}
  set assignId(v: undefined | number) {
    if (v !== undefined) {
      this.assignId__I = v;
      this.assignIdIsSet = true;
    } else {
      this.assignId__I = v || undefined;
      this.assignIdIsSet = true;
    }
    this.changeTracker = true;
  }
  get assignId() {
    return this.assignId__I;
  }
  sectionName__I?: string = undefined;
  sectionNameIsSet: boolean = false;
  set sectionName(v: undefined | string) {
    if (v !== undefined) {
      this.sectionName__I = v;
      this.sectionNameIsSet = true;
    } else {
      this.sectionName__I = v || undefined;
      this.sectionNameIsSet = false;
    }
    this.changeTracker = true;
  }
  get sectionName() {
    return this.sectionName__I;
  }
  active__I?: boolean = undefined;
  activeIsSet: boolean = false;
  set active(v: undefined | boolean) {
    if (v !== undefined) {
      this.active__I = v;
      this.activeIsSet = true;
    } else {
      this.active__I = v || undefined;
      this.activeIsSet = false;
    }
    this.changeTracker = true;
  }
  get active() {
    return this.active__I;
  }
  displayOrder__I?: number = undefined;
  displayOrderIsSet: boolean = false;
  set displayOrder(v: undefined | number) {
    if (v !== undefined) {
      this.displayOrder__I = v;
      this.displayOrderIsSet = true;
    } else {
      this.displayOrder__I = v || undefined;
      this.displayOrderIsSet = false;
    }
    this.changeTracker = true;
  }
  get displayOrder() {
    return this.displayOrder__I;
  }
  svgUrl__I?: string = undefined;
  svgUrlIsSet: boolean = false;
  set svgUrl(v: undefined | string) {
    if (v !== undefined) {
      this.svgUrl__I = v;
      this.svgUrlIsSet = true;
    } else {
      this.svgUrl__I = v || undefined;
      this.svgUrlIsSet = false;
    }
    this.changeTracker = true;
  }
  get svgUrl() {
    return this.svgUrl__I;
  }
  isDeleted__I?: boolean = undefined;
  isDeletedIsSet: boolean = false;
  set isDeleted(v: undefined | boolean) {
    if (v !== undefined) {
      this.isDeleted__I = v;
      this.isDeletedIsSet = true;
    } else {
      this.isDeleted__I = v || undefined;
      this.isDeletedIsSet = false;
    }
    this.changeTracker = true;
  }
  get isDeleted() {
    return this.isDeleted__I;
  }
  isNew__I?: boolean = undefined;
  isNewIsSet: boolean = false;
  set isNew(v: undefined | boolean) {
    if (v !== undefined) {
      this.isNew__I = v;
      this.isNewIsSet = true;
    } else {
      this.isNew__I = v || undefined;
      this.isNewIsSet = false;
    }
    this.changeTracker = true;
  }
  get isNew() {
    return this.isNew__I;
  }
  updatedOn__I?: Date = undefined;
  updatedOnIsSet: boolean = false;
  set updatedOn(v: undefined | Date) {
    if (v !== undefined) {
      this.updatedOn__I = v;
      this.updatedOnIsSet = true;
    } else {
      this.updatedOn__I = v || undefined;
      this.updatedOnIsSet = false;
    }
    this.changeTracker = true;
  }
  get updatedOn() {
    return this.updatedOn__I;
  }
  updatedBy__I?: string = undefined;
  updatedByIsSet: boolean = false;
  set updatedBy(v: undefined | string) {
    if (v !== undefined) {
      this.updatedBy__I = v;
      this.updatedByIsSet = true;
    } else {
      this.updatedBy__I = v || undefined;
      this.updatedByIsSet = false;
    }
    this.changeTracker = true;
  }
  get updatedBy() {
    return this.updatedBy__I;
  }
  createdOn__I?: Date = undefined;
  createdOnIsSet: boolean = false;
  set createdOn(v: undefined | Date) {
    if (v !== undefined) {
      this.createdOn__I = v;
      this.createdOnIsSet = true;
    } else {
      this.createdOn__I = v || undefined;
      this.createdOnIsSet = false;
    }
    this.changeTracker = true;
  }
  get createdOn() {
    return this.createdOn__I;
  }
  createdBy__I?: string = undefined;
  createdByIsSet: boolean = false;
  set createdBy(v: undefined | string) {
    if (v !== undefined) {
      this.createdBy__I = v;
      this.createdByIsSet = true;
    } else {
      this.createdBy__I = v || undefined;
      this.createdByIsSet = false;
    }
    this.changeTracker = true;
  }
  get createdBy() {
    return this.createdBy__I;
  }
  constructor(
    config?: JpClassSectionLookupFullOptional,
    options?: AssignOptions,
  ) {
    super(config, options);
    if (config) {
      this.assignFrom(config, options);
    }
  }
  equals(other?: any): boolean {
    if (this.assignIdIsSet == true && other?.assignIdIsSet == true)
      return this.assignId == other.assignId;

    return this == other;
  }
  setIds() {
    if (this.anySet() && !!this.assignId) {
      this.assignIdIsSet = true;
    }
  }
  assignFrom(
    config: JpClassSectionLookupFullOptional,
    options?: AssignOptions,
  ): JpClassSectionLookupFullTrackedI {
    const optionsRequired = getAssignOptions(options);
    if (config.assignId && this.assignIdApplyFilter(optionsRequired.filter)) {
      this.assignId = config.assignId;
      if (optionsRequired.unassign) this.assignIdIsSet = false;
      else this.assignIdIsSet = true;
    }
    if (
      config.sectionName &&
      this.sectionNameApplyFilter(optionsRequired.filter)
    ) {
      this.sectionName = config.sectionName;
      if (optionsRequired.unassign) this.sectionNameIsSet = false;
      else this.sectionNameIsSet = true;
    }
    if (config.active && this.activeApplyFilter(optionsRequired.filter)) {
      this.active = config.active;
      if (optionsRequired.unassign) this.activeIsSet = false;
      else this.activeIsSet = true;
    }
    if (
      config.displayOrder &&
      this.displayOrderApplyFilter(optionsRequired.filter)
    ) {
      this.displayOrder = config.displayOrder;
      if (optionsRequired.unassign) this.displayOrderIsSet = false;
      else this.displayOrderIsSet = true;
    }
    if (config.svgUrl && this.svgUrlApplyFilter(optionsRequired.filter)) {
      this.svgUrl = config.svgUrl;
      if (optionsRequired.unassign) this.svgUrlIsSet = false;
      else this.svgUrlIsSet = true;
    }
    if (config.isDeleted && this.isDeletedApplyFilter(optionsRequired.filter)) {
      this.isDeleted = config.isDeleted;
      if (optionsRequired.unassign) this.isDeletedIsSet = false;
      else this.isDeletedIsSet = true;
    }
    if (config.isNew && this.isNewApplyFilter(optionsRequired.filter)) {
      this.isNew = config.isNew;
      if (optionsRequired.unassign) this.isNewIsSet = false;
      else this.isNewIsSet = true;
    }
    if (config.updatedOn && this.updatedOnApplyFilter(optionsRequired.filter)) {
      this.updatedOn = config.updatedOn;
      if (optionsRequired.unassign) this.updatedOnIsSet = false;
      else this.updatedOnIsSet = true;
    }
    if (config.updatedBy && this.updatedByApplyFilter(optionsRequired.filter)) {
      this.updatedBy = config.updatedBy;
      if (optionsRequired.unassign) this.updatedByIsSet = false;
      else this.updatedByIsSet = true;
    }
    if (config.createdOn && this.createdOnApplyFilter(optionsRequired.filter)) {
      this.createdOn = config.createdOn;
      if (optionsRequired.unassign) this.createdOnIsSet = false;
      else this.createdOnIsSet = true;
    }
    if (config.createdBy && this.createdByApplyFilter(optionsRequired.filter)) {
      this.createdBy = config.createdBy;
      if (optionsRequired.unassign) this.createdByIsSet = false;
      else this.createdByIsSet = true;
    }
    if (optionsRequired.unassignChangeTracker) this.changeTracker = false;
    if (options?.isNew !== null && options?.isNew !== undefined)
      updateIsNew(this, optionsRequired.isNew);
    return this;
  }
  shouldRemove(skipPK: boolean = true): boolean {
    if (isNew(this) && isDeleted(this)) return true;
    return (
      !this.changeTracker && !this.anySet((a, b) => !skipPK || !a.isPrimary)
    );
  }
  removeUnset(filter?: FilterVarsType): JpClassSectionLookupFullTrackedI {
    const cloned = {} as JpClassSectionLookupFullTrackedI;
    if (
      this.assignIdIsSetDeep() &&
      this.assignIdApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.assignIdIsSet = true;
      cloned.assignId = this.assignId;
    } else {
      //cloned.assignIdIsSet = false
    }
    if (
      this.sectionNameIsSetDeep() &&
      this.sectionNameApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.sectionNameIsSet = true;
      cloned.sectionName = this.sectionName;
    } else {
      //cloned.sectionNameIsSet = false
    }
    if (
      this.activeIsSetDeep() &&
      this.activeApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.activeIsSet = true;
      cloned.active = this.active;
    } else {
      //cloned.activeIsSet = false
    }
    if (
      this.displayOrderIsSetDeep() &&
      this.displayOrderApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.displayOrderIsSet = true;
      cloned.displayOrder = this.displayOrder;
    } else {
      //cloned.displayOrderIsSet = false
    }
    if (
      this.svgUrlIsSetDeep() &&
      this.svgUrlApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.svgUrlIsSet = true;
      cloned.svgUrl = this.svgUrl;
    } else {
      //cloned.svgUrlIsSet = false
    }
    if (
      this.isDeletedIsSetDeep() &&
      this.isDeletedApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.isDeletedIsSet = true;
      cloned.isDeleted = this.isDeleted;
    } else {
      //cloned.isDeletedIsSet = false
    }
    if (
      this.isNewIsSetDeep() &&
      this.isNewApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.isNewIsSet = true;
      cloned.isNew = this.isNew;
    } else {
      //cloned.isNewIsSet = false
    }
    if (
      this.updatedOnIsSetDeep() &&
      this.updatedOnApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.updatedOnIsSet = true;
      cloned.updatedOn = this.updatedOn;
    } else {
      //cloned.updatedOnIsSet = false
    }
    if (
      this.updatedByIsSetDeep() &&
      this.updatedByApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.updatedByIsSet = true;
      cloned.updatedBy = this.updatedBy;
    } else {
      //cloned.updatedByIsSet = false
    }
    if (
      this.createdOnIsSetDeep() &&
      this.createdOnApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.createdOnIsSet = true;
      cloned.createdOn = this.createdOn;
    } else {
      //cloned.createdOnIsSet = false
    }
    if (
      this.createdByIsSetDeep() &&
      this.createdByApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.createdByIsSet = true;
      cloned.createdBy = this.createdBy;
    } else {
      //cloned.createdByIsSet = false
    }
    if (!isDeleted(this) && !this.assignIdIsSet) updateIsNew(cloned, true);
    return cloned;
  }
  unassignAll(filter?: FilterVarsType): JpClassSectionLookupFullTrackedI {
    if (!this.assignIdApplyFilter(filter)) this.assignIdIsSet = false;

    if (!this.sectionNameApplyFilter(filter)) this.sectionNameIsSet = false;

    if (!this.activeApplyFilter(filter)) this.activeIsSet = false;

    if (!this.displayOrderApplyFilter(filter)) this.displayOrderIsSet = false;

    if (!this.svgUrlApplyFilter(filter)) this.svgUrlIsSet = false;

    if (!this.isDeletedApplyFilter(filter)) this.isDeletedIsSet = false;

    if (!this.isNewApplyFilter(filter)) this.isNewIsSet = false;

    if (!this.updatedOnApplyFilter(filter)) this.updatedOnIsSet = false;

    if (!this.updatedByApplyFilter(filter)) this.updatedByIsSet = false;

    if (!this.createdOnApplyFilter(filter)) this.createdOnIsSet = false;

    if (!this.createdByApplyFilter(filter)) this.createdByIsSet = false;

    return this;
  }
  assignIdApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      JpClassSectionLookupFullMeta.assignId,
      JpClassSectionLookupFullMeta,
      this.assignId,
      this,
    );
  }
  assignIdIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.assignIdIsSet && this.assignIdApplyFilter(filter)) return true;

    return false;
  }
  sectionNameApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      JpClassSectionLookupFullMeta.sectionName,
      JpClassSectionLookupFullMeta,
      this.sectionName,
      this,
    );
  }
  sectionNameIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.sectionNameIsSet && this.sectionNameApplyFilter(filter))
      return true;

    return false;
  }
  activeApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      JpClassSectionLookupFullMeta.active,
      JpClassSectionLookupFullMeta,
      this.active,
      this,
    );
  }
  activeIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.activeIsSet && this.activeApplyFilter(filter)) return true;

    return false;
  }
  displayOrderApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      JpClassSectionLookupFullMeta.displayOrder,
      JpClassSectionLookupFullMeta,
      this.displayOrder,
      this,
    );
  }
  displayOrderIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.displayOrderIsSet && this.displayOrderApplyFilter(filter))
      return true;

    return false;
  }
  svgUrlApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      JpClassSectionLookupFullMeta.svgUrl,
      JpClassSectionLookupFullMeta,
      this.svgUrl,
      this,
    );
  }
  svgUrlIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.svgUrlIsSet && this.svgUrlApplyFilter(filter)) return true;

    return false;
  }
  isDeletedApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      JpClassSectionLookupFullMeta.isDeleted,
      JpClassSectionLookupFullMeta,
      this.isDeleted,
      this,
    );
  }
  isDeletedIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.isDeletedIsSet && this.isDeletedApplyFilter(filter)) return true;

    return false;
  }
  isNewApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      JpClassSectionLookupFullMeta.isNew,
      JpClassSectionLookupFullMeta,
      this.isNew,
      this,
    );
  }
  isNewIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.isNewIsSet && this.isNewApplyFilter(filter)) return true;

    return false;
  }
  updatedOnApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      JpClassSectionLookupFullMeta.updatedOn,
      JpClassSectionLookupFullMeta,
      this.updatedOn,
      this,
    );
  }
  updatedOnIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.updatedOnIsSet && this.updatedOnApplyFilter(filter)) return true;

    return false;
  }
  updatedByApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      JpClassSectionLookupFullMeta.updatedBy,
      JpClassSectionLookupFullMeta,
      this.updatedBy,
      this,
    );
  }
  updatedByIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.updatedByIsSet && this.updatedByApplyFilter(filter)) return true;

    return false;
  }
  createdOnApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      JpClassSectionLookupFullMeta.createdOn,
      JpClassSectionLookupFullMeta,
      this.createdOn,
      this,
    );
  }
  createdOnIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.createdOnIsSet && this.createdOnApplyFilter(filter)) return true;

    return false;
  }
  createdByApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      JpClassSectionLookupFullMeta.createdBy,
      JpClassSectionLookupFullMeta,
      this.createdBy,
      this,
    );
  }
  createdByIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.createdByIsSet && this.createdByApplyFilter(filter)) return true;

    return false;
  }
  anySet(filter?: FilterVarsType): boolean {
    if (this.changeTracker) return true;
    if (this.assignIdIsSetDeep(filter)) return true;
    if (this.sectionNameIsSetDeep(filter)) return true;
    if (this.activeIsSetDeep(filter)) return true;
    if (this.displayOrderIsSetDeep(filter)) return true;
    if (this.svgUrlIsSetDeep(filter)) return true;
    if (this.isDeletedIsSetDeep(filter)) return true;
    if (this.isNewIsSetDeep(filter)) return true;
    if (this.updatedOnIsSetDeep(filter)) return true;
    if (this.updatedByIsSetDeep(filter)) return true;
    if (this.createdOnIsSetDeep(filter)) return true;
    if (this.createdByIsSetDeep(filter)) return true;
    return false;
  }
}

import { transformDatesMap } from "@/api/mappers/dtoDateMapper";
